<template>
  <div>
    <div class="d-flex justify-start mt-10 mb-2">
      <h1>Commissions</h1>
    </div>
    <div v-for="comm in commissions" :key="comm.id">
      <ul class="mb-3">
        <li style="list-style-type: none">
          <b>{{ comm.firstName }} {{ comm.lastName }}</b>
          <ul style="list-style-type: square">
            <li><b>Role:</b> {{ comm.role | roleLabel }}</li>
            <li><b>Commission:</b> {{ comm.commission }}%</li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'commissions'
  ]
}
</script>
